export const view09ImageOptions = {
  angle: 'view09',
  staticOptions: {
    BowSprit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    Wheel: 1,
    BoomCover: 1,
    CockpitTable: 1,
    SelfTacker: 1,
    Sprayhood: 1
  },
  mattes: [
    {
      option: 'HullTreatment',
      dependency: null
    },
    {
      option: 'Deck',
      dependency: 'SelfTacker'
    },
    {
      option: 'Wheel',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X43MK2/views/view09.js